export default "__VITE_ASSET__Dt9b6lVb__"